import { abulesowo, april, autobest, autobestCover, doc, docCover, eclipse, fireswitch, img1, img4, journer, journerCover, mchrc, mchrcCover, reni, reniaccounts, renitrust, sinachpat, sinachpatCover, sublime, sublimeCover, flipCover, rfwaitlistCover, dafuqCover } from "../assets";
import { ICON_BOOTSTRAP, ICON_CSS, ICON_EMAIL, ICON_GIT, ICON_GITHUB, ICON_HTML, ICON_JAVASCRIPT, ICON_LINKEDIN, ICON_MDB, ICON_REACT, ICON_STYLED_COMPONENTS, ICON_TAILWIND, ICON_TWITTER, ICON_NEXTJS } from "./icons";


// Navbar

export const navLink = [
    { name: 'home', link: '/' },
    { name: 'projects', link: '/projects' },
    { name: 'about', link: '/about' },
    { name: 'contact', link: '/contact' },
];

// Navbar

// Home Page

export const heroData = {
    subtitle: 'LET\'S BUILD SOMETHING AMAZING TOGETHER',
    title: 'frontend engineer, creative developer & avid learner',
    content: 'I am Hammed Akinyemi, a passionate frontend engineer with a talent for crafting visually appealing websites that brings your unique vision to life with stunning design, flawless functionality, and unparalleled user experience.'
};

export const homeAbout = {
    subtitle: 'ABOUT',
    title: 'who am I',
    content: 'I am a skilled frontend developer with over 3 years of experience in Web Development. My passion for coding and web development began when I was a kid but manifested 3 years ago during ASUU strike in Nigeria. I joined Sheda House Academy and later Interned at FireSwitch Technologies. Since then, I have honed my skills in a variety of frontend programming languages, frameworks and expertise in coding, designing, and testing web applications.',
    image: img1
};

export const socials = [
    {
        icon: ICON_TWITTER,
        link: 'https://twitter.com/hammedakin_',
    },
    {
        icon: ICON_LINKEDIN,
        link: 'https://linkedin.com/in/hammedakin',
    },
    {
        icon: ICON_GITHUB,
        link: 'https://github.com/hammedakin',
    },
    {
        icon: ICON_EMAIL,
        link: 'mailto:hammedakin01@gmail.com',
    },
];

export const workTogether = {
    subtitle: 'LET\'S BUILD',
    title: 'want to work together?',
    content: 'We can do much together 😊, '
};

export const selectedProjects = {
    subtitle: 'PROJECTS',
    title: 'major projects I have worked on',

};

export const myClients = {
    subtitle: 'CLIENT',
    title: 'clients I’ve worked with',
    content: 'some organizations/communities I’ve contributed to and worked for',
    client: [
        reni, sublime, april, journer, sinachpat, autobest, fireswitch, mchrc, doc
    ],
};

// Home Page

// About Page
export const aboutHeader = {
    subtitle: 'ABOUT',
    title: 'I’m HammedAkin. I live s’where in the universe. where I build for clients across the globe.',
    img: img1
};

export const aboutMe = [
    'I am a skilled and talented frontend developer with a passion for creating stunning and functional websites that deliver an exceptional user experience. With over 3 years of experience in the industry, I have honed my skills and expertise in coding, designing, and testing web applications. My portfolio showcases my ability to create responsive websites that are optimized for various devices and platforms. I specialize in frontend development to ensure that the websites I develop are not only visually appealing but also easy to use and navigate.',
    'In addition to my professional life, I have a diverse set of interests that shape who I am outside the world of web development. As a football enthusiast, you\'ll often find me passionately supporting Chelsea FC. Whether it\'s cheering for my favorite team during a match or engaging in discussions about the latest football news, my love for the sport extends beyond the coding screen.',
    'When I\'m not immersed in the digital realm, I enjoy spending time in the kitchen experimenting with new recipes. Cooking serves as both a creative outlet and a way to unwind from the challenges of coding. I believe that just like coding, the perfect dish requires the right combination of elements and attention to detail.',
    'Apart from that, I am an avid cat lover. There\'s something incredibly comforting about the company of these furry companions. Their playful antics and independent personalities add a delightful balance to my life.',
    'Throughout my career, I\'ve had the opportunity to work on a wide range of projects, from simple websites to complex web applications. Some of my most notable projects include Reni Accounts, Sublime Education, and Eclipse Logistics. For each project, I worked on the implementing of the frontend interface, ensuring that the user experience was intuitive, visually appealing, and optimized for performance. By seamlessly blending my technical skills with my love for football, cooking, and cats, I aim to create a holistic and fulfilling professional and personal journey.',
    'I am a problem-solver who enjoys taking on challenges and finding innovative solutions. One of my strengths as a frontend developer is my ability to collaborate effectively with designers, back-end developers, and other stakeholders.  I understand that the success of a project depends on strong communication, attention to detail, and a commitment to quality.',
    'I am a quick learner with a passion for continuous learning and improvement, both in the coding world and in my personal interests. My commitment to delivering work that not only meets but exceeds expectations extends beyond the realm of web development, reflecting my dedication to quality in all aspects of my life.'
];

export const skills = {
    subtitle: 'SKILLS',
    title: 'tools and technologies',
    content: 'I’m a tool agnostic person but on most cases I’ve worked with this tools and technologies and I’m always willing to learn more tools and technologies.',
    tools: [
        { img: ICON_REACT, title: 'React JS' },
        { img: ICON_NEXTJS, title: 'Next JS' },
        { img: ICON_HTML, title: 'HTML' },
        { img: ICON_CSS, title: 'CSS' },
        { img: ICON_JAVASCRIPT, title: 'JavaScript' },
        { img: ICON_GIT, title: 'Git' },
        { img: ICON_GITHUB, title: 'Github' },
        { img: ICON_BOOTSTRAP, title: 'Bootstrap' },
        { img: ICON_MDB, title: 'MD Bootstrap' },
        { img: ICON_STYLED_COMPONENTS, title: 'Styled Components' },
        { img: ICON_TAILWIND, title: 'Tailwind' },
    ]
};

export const testimonials = {
    title: 'testimonials',
    subtitle: '',
    content: 'I’ve worked with professionals across the Globe who have these things to say about me -- 💙',
    slides: [
        {
            name: 'Ayodele Timothy',
            title: 'CEO, FireSwitch Technologies Ltd',
            content: 'I have worked with Akin on many project and in different capacities. He is incredibly reliable, resourceful and committed. He is a creative and talented developer that doubles a product developer, providing solutions as he implements. He is a team player, and valuable to any team or organization he belong. I\'d recommend him for opportunities in a heartbeat.',
        },
        {
            name: 'Comrade Kehinde A.',
            title: 'CEO, MCHRC',
            content: 'Working with Hammed was an absolute pleasure! His expertise in website development truly shines through. Our project was delivered on time, and the attention to detail was impeccable. The website not only meets but exceeds our expectations. Highly recommended!',
        },
        {
            name: 'David Omogunsoye',
            title: 'Product Designer',
            content: 'I\'ve had the privilege of collaborating with Hammed Akinyemi on multiple web development projects. His coding skills are top-notch, and they bring a unique blend of creativity and precision to every task.A true professional in the field.',
        },
        {
            name: 'Arijeniwa Victor',
            title: 'CEO, Sublime Education',
            content: 'As a business owner, having a strong online presence is crucial. Thanks to Mr. Akinyemi, our website is now a powerful tool for attracting customers. The user-friendly design and flawless functionality have significantly boosted our online visibility. Thank you for a job well done!',
        },
        {
            name: 'Mr. Oludare',
            title: 'CEO, Auto Best',
            content: 'In the fast-paced world of startups, finding a reliable and skilled web developer is a game-changer. Hammed Akinyemi not only met our tight deadlines but also delivered a website that perfectly aligns with our brand. Their ability to adapt to changing requirements sets them apart. Highly recommended for any startup looking to make a mark online.',
        },
    ]
};
// About Page

// Project Page
export const projectHeader = {
    subtitle: 'PROJECTS',
    title: 'We are here to put a dent in the universe, with these products/ projects, I’ve tried to.',
    content: 'Throughout my career, I have worked on numerous projects and I have carefully selected a few to showcase my value and expertise. I am confident that my experience and skills will contribute significantly to the success of your project.',
};

export const otherProjects = [

];

export const allProjects = [
    {
        id: 'renitrust',
        link: 'renitrust.com',
        img: renitrust,
        logo: reni,
        title: 'ReniTrust',
        subtitle: 'ReniTrust Escrow System',
        tools: ['ReactJs', 'Styled Component', 'Bootstrap', 'React Icons', 'Axios', ''],
        role: ['Frontend'],
        duration: '4 months',
        year: '2023',
        body: [
            {
                title: 'Overview',
                body: 'Renitrust is a web application designed to provide users with a secure escrow platform integrated with a robust wallet system. The platform offers various banking capabilities, including generating account numbers for transactions, facilitating payments for utilities such as airtime, data, electricity bills, and TV cable bills. Additionally, users can generate payment links for receiving payments and QR codes for requesting or sending payments to other users.'
            },
            {
                title: 'Objective',
                body: 'The primary objective of Renitrust is to establish a reliable and secure escrow system within a web application framework. The escrow system serves as the cornerstone of the platform, ensuring trust and security in financial transactions conducted by users. By providing a secure escrow service, Renitrust aims to instill confidence among users and facilitate seamless transactions for various purposes, including buying and selling goods or services. Additionally, Renitrust will offer users a seamless and secure platform for conducting financial transactions and managing their funds. With banking functionalities, the app aims to simplify the process of sending and receiving money while ensuring the security of transactions. This comprehensive approach not only fosters trust among users but also streamlines the entire transaction process, enhancing the overall user experience.'
            },
            {
                title: 'Approach',
                body: 'To achieve the objectives, the development team followed a systematic approach:  <br /> <br/>    <ol>  <li>  Requirement Analysis: Understanding the needs of users and identifying key features required for the platform, such as escrow services, wallet management, and utility bill payments. </li> <br/> <li>   Design Phase: Creating an intuitive user interface that allows users to navigate through the platform effortlessly. Designing secure mechanisms for generating payment links and QR codes.  </li> <br/>  <li>   Development: Implementing the backend infrastructure for escrow services and wallet management. Integrating APIs for utility bill payments and QR code generation.  </li> <br/>  <li>      Testing: Conducting rigorous testing to ensure the reliability, security, and performance of the platform across different devices and browsers.  </li> <br/> <li>  Deployment: Deploying the application to a secure server environment and ensuring scalability to accommodate increasing user demand. </li> </ol>'
            },
            {
                title: 'Result',
                body: 'The implementation of Renitrust yielded the following results:      <br/> <br/>    <ol>  <li>  Secure Escrow Platform: Users can conduct transactions with confidence, knowing that their funds are protected through the escrow service.      </li> <br/> <li>  Efficient Wallet System: The integrated wallet system enables users to manage their funds effectively, including purchasing airtime, data, and paying utility bills.  </li> <br/>  <li>  Convenient Payment Features: Users can generate payment links to receive payments or QR codes to request or send payments, enhancing the convenience of financial transactions.  </li> <br/>  <li>   User Satisfaction: Positive feedback from users regarding the ease of use, security, and convenience offered by the platform.  </li> </ol>'
            },
            {
                title: 'Conclusion',
                body: 'In conclusion, Renitrust successfully achieves its objective of providing users with a secure escrow platform integrated with banking capabilities. The platform\'s intuitive design, robust features, and emphasis on security contribute to a seamless user experience. Moving forward, continuous updates and enhancements will be made to ensure that Renitrust remains a trusted and reliable financial solution for users.'
            },

        ],
        images: [],
        selected: true,
        // prev: '',
        next: 'reni_finance_waitlist',
        comingSoon: false,
    },
    {
        id: 'reni_finance_waitlist',
        link: 'finance.reni.one',
        img: rfwaitlistCover,
        logo: reni,
        title: 'Reni Finance',
        subtitle: 'Reni Finance Waitlist',
        tools: ['NextJs', 'Tailwind CSS', 'React Icons', 'Axios',],
        role: ['Frontend'],
        duration: '5 days',
        year: '2025',
        body: [
            {
                title: 'Overview',
                body: 'At FireSwitch Technologies, as a frontend developer, I am part of a team consisting of product designers, a product manager and developers. We were responsible for developing an accounting web app that specializes in working with individual users and businesses. The web app is designed to provide users with an easy-to-use platform to manage their finances, track expenses, record sales, create invoices and access financial reports.'
            },
            {
                title: 'Objective',
                body: 'The objective of the web app is to provide small business owners with a simple and efficient way to manage their finances without having to worry about the technical details of accounting. The web app needed to be user-friendly, easy to navigate, and responsive to different devices and screen sizes.'
            },
            {
                title: 'Approach',
                body: 'We approached the project by first conducting a thorough analysis of the businesses’ requirements and their target audience. Based on this research, the designers developed a design that emphasized simplicity, ease of use, and visual appeal. <br/><br/> To achieve this, we created a clean and modern design that used a minimal color palette and simple typography. We used white space effectively to highlight important information and make the web app feel spacious and uncluttered. <br/><br/>  In terms of functionality, we created a dashboard that allowed users to access their financial reports and track expenses in real-time. We also included a feature that allowed users or businesses track their report monthly. To ensure the website was responsive to different screen sizes, I used a mobile-first approach and tested the website on multiple devices and screen sizes.'
            },
            {
                title: 'Conclusion',
                body: 'Reni Finance will be a great opportunity to showcase my frontend development skills, and demonstrate my ability to create user-friendly interfaces and responsive designs.'
            },

        ],
        images: [],
        selected: true,
        prev: 'renitrust',
        next: 'journer',
        comingSoon: false,
    },
    {
        id: 'reni_finance',
        link: 'reniaccounts.com',
        img: reniaccounts,
        logo: reni,
        title: 'Reni Finance',
        subtitle: 'Reni Finance for Businesses',
        tools: ['ReactJs', 'Styled Components', 'Bootstrap', 'React Icons', 'Axios', 'Apex Chart',],
        role: ['Frontend'],
        duration: '7 months',
        year: '2022',
        body: [
            {
                title: 'Overview',
                body: 'At FireSwitch Technologies, as a frontend developer, I am part of a team consisting of product designers, a product manager and developers. We were responsible for developing an accounting web app that specializes in working with individual users and businesses. The web app is designed to provide users with an easy-to-use platform to manage their finances, track expenses, record sales, create invoices and access financial reports.'
            },
            {
                title: 'Objective',
                body: 'The objective of the web app is to provide small business owners with a simple and efficient way to manage their finances without having to worry about the technical details of accounting. The web app needed to be user-friendly, easy to navigate, and responsive to different devices and screen sizes.'
            },
            {
                title: 'Approach',
                body: 'We approached the project by first conducting a thorough analysis of the businesses’ requirements and their target audience. Based on this research, the designers developed a design that emphasized simplicity, ease of use, and visual appeal. <br/><br/> To achieve this, we created a clean and modern design that used a minimal color palette and simple typography. We used white space effectively to highlight important information and make the web app feel spacious and uncluttered. <br/><br/>  In terms of functionality, we created a dashboard that allowed users to access their financial reports and track expenses in real-time. We also included a feature that allowed users or businesses track their report monthly. To ensure the website was responsive to different screen sizes, I used a mobile-first approach and tested the website on multiple devices and screen sizes.'
            },
            {
                title: 'Result',
                body: 'Reni account was a huge success, with positive feedback from both the client and their clients. The web app was easy to use and helped clients manage their finances efficiently. The modern design and user-friendly interface also helped to differentiate the accounting firm from their competitors, and attract new clients to their business.'
            },
            {
                title: 'Conclusion',
                body: 'Reni Account was a great opportunity to showcase my frontend development skills, and demonstrate my ability to create user-friendly interfaces and responsive designs.'
            },

        ],
        images: [],
        selected: false,
        prev: 'renitrust',
        next: 'journer',
        comingSoon: true,
    },
    {
        id: 'journer',
        link: 'journer.netlify.app',
        img: journerCover,
        logo: journer,
        title: 'Journer',
        subtitle: 'Journer for Note Taking ',
        tools: ['ReactJs', 'CSS', 'Bootstrap', 'Bootstrap Icon', 'Axios', 'NodeJS', 'ExpressJS', 'MongoDB', 'JWT'],
        role: ['Frontend', 'Backend'],
        duration: '7 months',
        year: '2022',
        body: [
            {
                title: 'Overview',
                body: 'As a software developer, I created, designed and developed a web app called Journer, which is a note-taking app that allows users to create and organize their notes in a user-friendly way.',
            },
            {
                title: 'Objective',
                body: 'The objective of the project was to create a note-taking web app that was intuitive and easy to use, while also being visually appealing and engaging for users. The app needed to allow users to create, edit, and delete notes, as well as organize their notes into different categories and tags.',
            },
            {
                title: 'Approach',
                body: 'I began the project by conducting a thorough analysis of the user\'s requirements and expectations for the app. Based on this research, I developed a design that emphasized simplicity, user- friendliness, and visual appeal. <br/> <br/>To achieve this, I created a clean and modern design that used a minimalist color palette and simple typography. I used white space effectively to highlight important information and make the app feel spacious and uncluttered. <br/> <br/> In terms of functionality, I created a note - taking interface that allowed users to easily create and edit notes, with the ability to add tags and categorize their notes. Task was also added for easy reminder of things to do at a particular time and date. I also included a search feature that allowed users to quickly find specific notes. <br/> <br/> To ensure that the app was responsive to different screen sizes and devices, I used a mobile - first approach and tested the app on multiple devices and screen sizes.',
            },
            {
                title: 'Result',
                body: 'Journer was a huge success, with positive feedback from users who found the app intuitive, easy to use, and visually appealing. The app helped users to organize their notes in a way that made sense to them, and the minimalist design helped to reduce distraction and improve focus. The app also helped to differentiate itself from other note - taking apps on the market.',
            },
            {
                title: 'Conclusion',
                body: 'Journer was a great opportunity to showcase my full-stack development skills and demonstrate my ability to create user-friendly interfaces, responsive designs and well structured backend.',
            },

        ],
        images: [],
        selected: false,
        prev: 'reni_finance_waitlist',
        next: 'sublime',
        comingSoon: false,
    },
    {
        id: 'sublime',
        link: 'sublimeedu.vercel.app',
        img: sublimeCover,
        logo: sublime,
        title: 'Sublime Education',
        subtitle: 'Sublime Education Website',
        tools: ['React JS', 'Bootstrap', 'Styled Components', 'React Icons'],
        role: ['Frontend'],
        duration: '1 week',
        year: '2023',
        body: [
            {
                title: 'Project Summary',
                body: 'I collaborated with a talented UI designer to bring to life the vision for the Sublime Educations website, a platform dedicated to facilitating student travel from Nigeria to various countries overseas. The website not only showcases a visually appealing design but also integrates seamless functionality to enhance the overall user experience.  <br/> I partnered with a skilled UI designer <a href="https://twitter.com/Meedayyy" target="_blank" class="project-link"> (Meeday)</a> who conceptualized and crafted a visually engaging interface, ensuring that the design aligns with the brand identity and appeals to the target audience. <br/>  <br/> <b> Key Features </b> <br/> <ol> <li>Intuitive User Experience: Implemented a user-centric design approach to create an intuitive and easy-to-navigate platform. This is crucial for prospective student travelers and their parents to explore the services offered by Sublime Educations.</li > <br/><li>Comprehensive Travel Information: Integrated a section that provides comprehensive information about travel procedures, documentation, and destination details. This assists users in making informed decisions regarding their international student travel. </li> <br/><li>Interactive Inquiry and Booking System: Developed an interactive system that allows users to make inquiries, receive quotes, and initiate bookings directly through the website. This feature streamlines the communication process and enhances the overall efficiency of service delivery.</li> <br/></ol > Utilized modern web development technologies, ReactJs, Styled Component and Bootstrap, to ensure a responsive and seamless performance across various devices. <br/> The collaboration stemmed from a referral by a UI designer who had successfully translated the client\'s vision into a compelling visual design. This collaboration ensured a cohesive transition from design to development, resulting in a harmonious and effective end product.',
            },
            {
                title: 'Conclusion',
                body: 'This project not only demonstrates my proficiency in web development but also highlights the synergy achieved through collaboration with a UI designer. The Sublime Educations website stands as a testament to the seamless integration of design and functionality to meet the unique needs of a client operating in the student travel sector.',
            },
        ],
        images: [],
        selected: true,
        prev: 'journer',
        next: 'flip',
        comingSoon: false,
    },
    {
        id: 'autobest',
        link: '#',
        img: autobestCover,
        logo: sublimeCover,
        title: 'Auto Best',
        subtitle: 'Auto Best Website',
        tools: ['React JS', 'Bootstrap', 'Styled Components', 'React Icons', 'Axios'],
        role: ['Frontend'],
        duration: '1 month',
        year: '2023',
        body: [
            {
                title: 'Project Summary',
                body: '',
            },
            {
                title: 'Conclusion',
                body: '',
            },

        ],
        images: [],
        selected: false,
        // prev: 'sublime',
        // next: 'eclipse',
        comingSoon: true,
    },
    {
        id: 'flip',
        link: 'flipthefrog.club',
        img: flipCover,
        logo: flipCover,
        title: 'FLIP THE FROG',
        subtitle: 'Flip the frog Website',
        tools: ['ReactJs', 'CSS', 'Bootstrap', 'AOS', 'Vercel'],
        role: ['Frontend'],
        duration: '1 day',
        year: '2024',
        body: [
            {
                title: 'Project Summary',
                body: 'Flip the frog is a memecoin hosted on the Solana Blockchain.',
            },

            {
                title: 'Conclusion',
                body: 'This project not only underscores my proficiency in frontend development, particularly with React.js, but also highlights my ability to create simple but unique websites',
            },

        ],
        images: [],
        selected: false,
        prev: 'sublime',
        next: 'eclipse',
        comingSoon: false,
    },
    {
        id: 'eclipse',
        link: 'eclipse.com.ng',
        img: eclipse,
        logo: eclipse,
        title: 'Eclipse Logistics',
        subtitle: 'Eclipse Logistics Web App',
        tools: ['ReactJs', 'CSS', 'Bootstrap', 'BoxIcon', 'Axios'],
        role: ['Frontend'],
        duration: '3 months',
        year: '2021',
        body: [
            {
                title: 'Project Summary',
                body: 'I had the privilege of being part of team that developed a comprehensive web application for Eclipse Logistics, a prominent logistics company. The primary goal was to offer users a comprehensive and user- friendly platform for their logistics requirements.Leveraging React.js for the frontend, I successfully crafted an intuitive platform that enables users to seamlessly book deliveries, obtain instant quotes, and even facilitate food purchases within a unified interface. <br/> <br/>  <b> Key Features: </b>  <br/>    <ol>       <li>            Online Booking System: Implemented a user-friendly booking system that allows clients to schedule deliveries effortlessly through a straightforward interface.        </li><br/>        <li>            Instant Quote Generation: Integrated a dynamic quoting system, providing users with real-time estimates based on their specific requirements, ensuring transparency and accuracy.        </li><br/>        <li>            Food Purchasing Module: Expanded the functionality to include a food ordering system, enabling users to conveniently purchase meals through the same platform, thereby enhancing the app\'s utility.        </li><br/>  <li>            Referral System: Introduced a referral program to encourage user engagement and customer loyalty. This feature rewards users for referring others to the platform, fostering a sense of community and incentivizing growth.        </li>    </ol><br/>The Eclipse Logistics web app now stands as a testament to the successful fusion of modern technology and logistics solutions, offering a user - centric and efficient platform for a diverse range of logistics requirements.<br/>The project lays the foundation for potential future enhancements, such as real - time tracking, personalized user dashboards, and integration with external APIs to further elevate the logistics and user experience.',
            },

            {
                title: 'Conclusion',
                body: 'This project not only underscores my proficiency in frontend development, particularly with React.js, but also highlights my ability to understand and address the unique challenges of a logistics company, translating them into a tailored and impactful digital solution.',
            },

        ],
        images: [],
        selected: false,
        prev: 'flip',
        next: 'dafuq',
        comingSoon: false,
    },
    {
        id: 'dafuq',
        link: 'dafuq.club',
        img: dafuqCover,
        logo: dafuqCover,
        title: 'Dafuq',
        subtitle: 'Dafuq Memecoin Website',
        tools: ['ReactJs', 'CSS', 'Bootstrap', 'AOS', 'Vercel'],
        role: ['Frontend'],
        duration: '3 days',
        year: '2024',
        body: [
            {
                title: 'Project Summary',
                body: 'Dafuq is a memecoin hosted on the Solana Blockchain.',
            },

            {
                title: 'Conclusion',
                body: 'This project not only underscores my proficiency in frontend development, particularly with React.js, but also highlights my ability to create simple but unique websites',
            },

        ],
        images: [],
        selected: false,
        prev: 'eclipse',
        next: 'sinachpat',
        comingSoon: false,
    },
    {
        id: 'sinachpat',
        link: 'sinach.vercel.app',
        img: sinachpatCover,
        logo: sinachpat,
        title: 'Osinachi Patrick',
        subtitle: 'Osinachi Patrick Portfolio',
        tools: ['ReactJs', 'CSS', 'Bootstrap', 'Styled Component', 'Bootstrap Icon', 'Axios', 'Medium API'],
        role: ['Frontend'],
        duration: '1 months',
        year: '2022',
        body: [
            {
                title: 'Project Summary',
                body: 'I had the pleasure of collaborating with a talented UI designer (Osinachi Patrick) to bring the vision of the his website to life. This platform serves as a showcase for Osinachi\'s exceptional skills in user interface (UI) and user experience (UX) design. The website features an array of projects, detailed case studies, and insightful articles, providing visitors with a comprehensive insight into Osinachi\'s design philosophy and expertise. <br/> Collaborated closely with the him to seamlessly translate the intricate design elements into a fully functional and visually appealing website. The goal was to create an online space that not only reflects Osinachi\'s design prowess but also ensures an immersive and engaging user experience.  <br/> <br/> <b> Key Features </b> <br/> <ol> <li>Project Showcase: Developed a dedicated section to showcase Osinachi\'s portfolio, highlighting various UI/UX design projects. Each project is presented with meticulous attention to detail, allowing visitors to appreciate the depth and creativity behind each design endeavor.</li> <br/><li>In-Depth Case Studies: Implemented an interactive case studies section, providing in-depth insights into the design process, challenges faced, and solutions employed for selected projects. This serves as both a portfolio highlight and an educational resource for aspiring designers. </li> <br/><li>Interactive Inquiry and Booking System: Developed an interactive system that allows users to make inquiries, receive quotes, and initiate bookings directly through the website. This feature streamlines the communication process and enhances the overall efficiency of service delivery.</li> <br/></ol> Utilized modern web development technologies, ReactJs, Animate on Scroll, Styled Component and Bootstrap, to ensure a responsive and seamless performance across various devices. This collaboration stemmed from a referral by a UI designer, emphasizing the importance of a well-coordinated design development partnership. The website reflects a cohesive blend of design aesthetics and functional efficiency.',
            },
            {
                title: 'Conclusion',
                body: 'The Osinachi Portfolio website stands as a testament to the successful fusion of design and development expertise. It not only showcases Osinachi\'s creative talent but also represents a collaborative effort to create a digital space that is both visually stunning and functionally robust.',
            },
        ],
        images: [],
        selected: false,
        prev: 'dafuq',
        next: 'mchrc',
        comingSoon: false,
    },
    {
        id: 'mchrc',
        link: 'mchrc.netlify.app',
        img: mchrcCover,
        logo: mchrc,
        title: 'Mediation and Justice',
        subtitle: 'Mediation and Justice Website',
        tools: ['React JS', 'Bootstrap', 'Bootstrap Icon', ''],
        role: ['Frontend'],
        duration: '2 weeks',
        year: '2021',
        body: [
            {
                title: 'Project Summary',
                body: 'I  designed and developed of Mediation and Human Rights Center (MCHRC) website, a digital platform for an organization dedicated to advocating for human rights and providing mediation services. The website serves as a vital tool in amplifying MCHRC\'s mission, facilitating access to information, and showcasing their commitment to justice and humanitarian causes. <br/> The project involved a comprehensive collaboration between design and development, with a focus on creating a visually compelling and functionally robust website.The seamless integration of design elements and technological functionalities ensured an immersive user experience.  <br/><br/> <b> Key Features </b> <br/> <ol> <li>Mission Clarity and Advocacy: Designed the website to clearly communicate MCHRC\'s mission, values, and dedication to human rights. The strategic placement of content emphasizes the organization\'s commitment to advocating for individuals whose rights have been violated. </li> <br/><li>Mediation Services Overview: Developed a dedicated section outlining MCHRC\'s mediation services. This provides users with a comprehensive understanding of the company\'s capabilities in resolving conflicts and promoting peaceful solutions. </li> <br/><li> Case Studies and Success Stories: Integrated case studies and success stories to showcase MCHRC\'s impact and successes in advocating for individuals and communities. These real-world examples serve as a testament to the organization\'s effectiveness in safeguarding human rights. </li> <br/> <li> Contact and Support Channels: Implemented clear and accessible contact channels, encouraging individuals seeking assistance or information to reach out easily. This ensures that MCHRC remains approachable and available to those in need of support.</li> <br/></ol> Utilized a modern technological stack, to create a responsive and secure website that effectively conveys MCHRC\'s message across various devices.',
            },
            {
                title: 'Conclusion',
                body: 'MCHRC website not only serves as an informative platform but also acts as a catalyst for impactful advocacy. It empowers the organization to reach a wider audience, fostering awareness and support for human rights causes. <br/> The MCHRC website stands as a testament to the fusion of design and development expertise in the service of a noble cause. By providing a digital hub for advocacy and information, the website reinforces MCHRC\'s position as a key player in the fight for justice and human rights.',
            },

        ],
        images: [],
        selected: false,
        prev: 'sinachpat',
        next: 'abulesowo',
        comingSoon: false,
    },
    {
        id: 'abulesowo',
        link: 'abulesowo.netlify.app',
        img: abulesowo,
        logo: abulesowo,
        title: 'Abulesowo',
        subtitle: 'Abulesowo Website',
        tools: ['React JS', 'Bootstrap', 'Bootstrap Icon', ''],
        role: ['Frontend'],
        duration: '2 months',
        year: '2021',
        body: [
            {
                title: 'Project Summary',
                body: 'I was tasked with the frontend development of a robust website for Abulesowo, a prominent real estate company specializing in property sales, land transactions, house rentals, and leasing services. The website is designed to provide a seamless user experience, offering features such as detailed property listings, visit requests, advanced property search filters, and client testimonials. <br/> Fostered seamless communication between Abulesowo and its clients by incorporating interactive features such as property visit requests. The website acts as a valuable tool for client engagement, enhancing the overall customer relationship management process.<br/> <br/> <b> Key Features </b> <br/> <ol> <li>Comprehensive Property Listings: Developed a user-friendly platform that presents a comprehensive list of available properties and land. Each listing includes detailed information, high-quality images, and essential details to assist potential buyers and tenants in making informed decisions. </li> <br/><li>Visit Request Functionality: Implemented a feature that allows users to request property visits directly through the website. This streamlines the communication process between potential clients and the Abulesowo team, enhancing the overall customer experience. </li> <br/><li> Advanced Property Search with Filters: Designed and integrated a robust search functionality with filters, enabling users to narrow down property options based on specific criteria such as location, size, and price range.This enhances the efficiency of the property search process. </li> <br/> <li>Testimonials Section: Incorporated a testimonials section where satisfied clients can share their experiences with Abulesowo. This not only serves as a trust-building element for potential clients but also highlights the company\'s successful track record in the real estate market.</li></ol> <br/> Utilized  modern technological stacks to ensure a secure, responsive, and user - friendly website that meets the dynamic needs of the real estate industry.',
            },
            {
                title: 'Conclusion',
                body: 'The Abulesowo Real Estate website is a testament to the successful integration of technology in the real estate sector. By providing a user-friendly interface, detailed property information, and streamlined communication channels, the website contributes to Abulesowo\'s mission of connecting clients with their ideal properties.',
            },

        ],
        images: [],
        selected: false,
        prev: 'mchrc',
        next: 'doc',
        comingSoon: false,
    },
    {
        id: 'doc',
        link: 'doc-portfolio.netlify.app',
        img: docCover,
        logo: docCover,
        title: 'David Omogunsoye',
        subtitle: 'David Omogunsoye Portfolio',
        tools: ['React JS', 'Bootstrap', 'Bootstrap Icon', ''],
        role: ['Frontend'],
        duration: '2 weeks',
        year: '2020',
        body: [
            {
                title: 'Project Summary',
                body: 'I collaborated with UI designer David Omogunsoye to bring his visionary designs to life in the "David Omogunsoye Portfolio" website. This platform showcases David\'s expertise in UI/ UX design, featuring visually striking project displays, interactive case studies, and insightful articles.The project emphasized a seamless blend of design aesthetics and functional efficiency to ensure an intuitive user experience. <br/> Key features include a visually appealing project showcase, in-depth case studies offering design insights, and a thoughtfully curated articles section highlighting David\'s industry expertise. The technological stack employed ensures a responsive and user-friendly browsing experience across devices. <br/> The collaboration was initiated by David, emphasizing the importance of a cohesive design- development partnership.The website serves as a dynamic hub for David\'s evolving design expertise, designed for scalability to accommodate future enhancements. <br/> In conclusion, the David Omogunsoye Portfolio website stands as a testament to the successful fusion of design and development, providing a showcase for David\'s talent, thought leadership, and contributions to the UI/UX design community.',
            },

        ],
        images: [],
        selected: false,
        prev: 'abulesowo',
        // next: '',
        comingSoon: false,
    },
];

// Project Page


// Contact Page
export const contactHeader = {
    subtitle: 'CONTACT',
    title: 'let\'s chat. <br/> Tell me about your brilliant idea, we will build something extraodinary',
    img: img4
};

export const contactDetails = {
    subtitle: 'LET\'S TALK',
    content: 'I enjoy working with dedicated individuals, organizations and businesses that make the world beautiful. <br/><br/> We can do much together 😊',
    contact: [
        {
            title: 'If you want to mail:',
            link: 'mailto:hammedakin01@gmail.com',
            connect: 'email me 📧'
        },
        {
            title: 'If you want to hear my voice:',
            link: 'tel:+2348062474043',
            connect: 'call me 🤙'
        },
        {
            title: 'If you want to see me irl:',
            link: '#!',
            connect: 's\'where on Planet Earth 🌍'
        },
    ]
};
// Contact Page